import axios from 'axios';

const config = {
    baseURL: 'https://cl.fastmin.com'
}

const http = axios.create(config);

export default http
